import store from '@/packages/vuex'
import { INSPECT_TOKENS, FETCH_MFA_STATUS } from '@/store/modules/Auth/action-types'
import { Middleware } from '@/app/router'

export default new Middleware('Token validation', async ({ to, next }) => {
	if (!to.matched.some(record => record.meta.skipInspect)) {
		await store.dispatch('Auth/' + INSPECT_TOKENS)

		// Evaluate MFA status for resumed sessions before protected routes
		// render, so the enforcement middleware can redirect to mandatory
		// enrollment before any dashboard data loads.
		if (store.getters['Auth/authenticated'] && !store.getters['Auth/mfa'].fetched) {
			try {
				await store.dispatch('Auth/' + FETCH_MFA_STATUS)
			} catch (_e) {
				// Status unavailable (e.g. network). The backend still enforces
				// enrollment server-side and the Apollo error link routes to it.
			}
		}
	}
	return next()
})
